import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../Transitions";
import emailjs from "@emailjs/browser";
import { contacts } from "../Data";

const Contact = () => {
  const form = useRef();
  const [messageSent, setMessageSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_ibylisq",
        "template_4vi0t0e",
        form.current,
        "uI6dem_EN1VmtKRlW"
      )
      .then(
        (result) => {
          setMessageSent(true);
          e.target.reset("Message sent");
        },
        (error) => {}
      );
  };

  return (
    <section className="py-16 lg:section" id="contact">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row">

          <motion.div
          variants={fadeIn("right", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.3 }}
          className="flex-1 flex justify-start items-center">

            <div>
              <h4 className="text-xl uppercase text-accent font-medium mb-2 tracking-wide">
                Get in touch
              </h4>
              <h2 className="text-[45px] lg:text-[60px] leading-none mb-12 ">
                Come work <br /> with me
              </h2>
            </div>
          </motion.div>

          <motion.form ref={form} onSubmit={sendEmail}
          variants={fadeIn("left", 0.3)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.7 }}
          
          className="flex-1 border rounded-2xl flex flex-col gap-y-6 pb-24 p-6 items-start">
            <input
              className="bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all"
              type="text"
              name="name"
              placeholder="Name"
            />

            <input
              className="bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all"
              type="email"
              name="user_email"
              placeholder="Email"
            />

            <input
              className="bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all"
              type="text"
              name="budget"
              placeholder="Budget"
            />

            <textarea
              className="bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all resize-none mb-12"
              placeholder="Message"
              name="message"
            />

            <button className="btn btn-lg text-[0.9rem] text-blue"
              type="submit"
              value="Send"
              
            >
              Send message
            </button>
            {messageSent && (
              <p className="text-white">Message Sent!</p>
            )}
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
